"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { useEffect } from "react";

import { disablePosthogSessionRecording } from "@/config/flags";
import { posthogConfig } from "@/config/posthog";

import { isProduction } from "@/lib/utils/env";

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  return <PostHogProviderComponent>{children}</PostHogProviderComponent>;
}

// https://posthog.com/docs/libraries/next-js
// https://us.posthog.com/project/135096/onboarding/product_analytics?step=install
function PostHogProviderComponent({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    posthog.init(posthogConfig?.projectKey as string, {
      // https://posthog.com/docs/advanced/proxy/nextjs
      api_host: posthogConfig?.clientProxyPath,
      capture_pageview: "history_change", // Best practice for SPA events: https://posthog.com/docs/libraries/next-js#why-did-the-pageview-component-need-a-useeffect
      capture_pageleave: "if_capture_pageview", // Needed to enable automatic $pageleave events when using history_change above
      disable_session_recording: disablePosthogSessionRecording(),
      person_profiles: "identified_only", // or 'always' to create profiles for anonymous users as well
      ui_host: posthogConfig?.uiHost,
    });

    if (!isProduction()) {
      // attached to window object for e2e tests
      window.posthog = posthog;
    }
  }, []);

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
